/* eslint-disable */
import React, {PropTypes} from 'react';
import Helpers from '../../util/Helpers'
import $ from 'jquery';
import {Chart, Bar} from 'react-chartjs-2';
import 'chartjs-plugin-datalabels';



class GrafBarraTempoRespostaFaixa extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            idNatureza: 0,
            
        };
        
        this.getFaixa = this.getFaixa.bind(this);
    }
    getFaixa(obj) {
        
        if (obj.length > 0) {
            
            //metodo da dashboard que passará o id para a modal. 
           //console.log('clicou em q gráfico ',this.props.relatorio.dado[obj[0]._index].mFaixaTempoResposta);
            this.props.obtemFaixaSelecionada(this.props.relatorio.dado[obj[0]._index].mFaixaTempoResposta)
        }
    }

    render() {
        
      if($.isEmptyObject(this.props.relatorio)){
          return <div></div>
      }
    
    //console.log('tempo médio - barra ', this.props.relatorio);
    
     
    var graficoBar = null;
    var totalManifestacoes = 0;
    if(!$.isEmptyObject(this.props.relatorio)){
        const dataBar = {
            labels: this.props.relatorio.dado.map(item => {
                return Helpers.obterFaixaTempoResposta(item.mFaixaTempoResposta) //+ ' - ' + item.mTotalMensagens 
            }),
            datasets: [{
                data: this.props.relatorio.dado.map(item => {
                    totalManifestacoes+=item.mQuantidade;
                    return item.mQuantidade
                }),
                    datalabels: {
                        align: 'end',
                        anchor: 'end'
                    },
                label: 'Quantidade: ',
                borderWidth: 1,
                //hoverBackgroundColor: 'rgba(255,99,132,0.4)',
                //hoverBorderColor: 'rgba(255,99,132,1)',
                backgroundColor: this.props.relatorio.dado.map(item => {
                                    return Helpers.obterCoresFaixaTempoRespostaRGBa(Helpers.obterFaixaTempoResposta(item.mFaixaTempoResposta), '0.8') //+ ' - ' + item.mTotalMensagens 
                                 }),
                borderColor: this.props.relatorio.dado.map(item => {
                                    return Helpers.obterCoresFaixaTempoRespostaRGBa(Helpers.obterFaixaTempoResposta(item.mFaixaTempoResposta), '0.1') //+ ' - ' + item.mTotalMensagens 
                                 }),
                hoverBackgroundColor: this.props.relatorio.dado.map(item => {
                                    return Helpers.obterCoresFaixaTempoRespostaRGBa(Helpers.obterFaixaTempoResposta(item.mFaixaTempoResposta), '0.9') //+ ' - ' + item.mTotalMensagens 
                                 }),
                hoverBorderColor: this.props.relatorio.dado.map(item => {
                                    return Helpers.obterCoresFaixaTempoRespostaRGBa(Helpers.obterFaixaTempoResposta(item.mFaixaTempoResposta), '1') //+ ' - ' + item.mTotalMensagens 
                                 }),
                }]
           
        };
        const optionsBar = {
            plugins: {
                datalabels: {
                    backgroundColor: function(context) {
                        return context.dataset.backgroundColor;
                    },
                    borderRadius: 4,
                    color: 'white',
                    font: {
                        weight: 'bold'
                    },
                    formatter: Math.round
                }
            },scales: {
                yAxes: [{
                    stacked: false
                }],
                xAxes: [{
                    barPercentage: 0.5,
                    barThickness: 35,
                    maxBarThickness: 35,
                    minBarLength: 1,
                    gridLines: {
                        offsetGridLines: true
                    }
                }]
            },
            title: {
            display: true,
            text: 'Tempo de resposta das '+ totalManifestacoes +' finalizadas exceto denúncias - valor quantitativo'
        },
        legend: {
            display: false,
            labels: {
                fontColor: '#000000'
            }
        },
        tooltips:{
                    enabled:true
                }
        };

       
       //console.log('relatório GrafBarraTempoRespostaFaixa -> ', this.props.relatorio);
        
         graficoBar = (
                <Bar ref='tempoResposta'
                    data={dataBar}
                    width={80}
                    height={41}
                    options={{
                        maintainAspectRatio: true
                    }}
                    options={optionsBar}
                    onElementsClick={this.getFaixa}
                 />
        )

    }
     return (
        <div>
            {graficoBar}
        </div>
        
    );
  }
}

export default GrafBarraTempoRespostaFaixa;


/** WEBPACK FOOTER **
 ** ./src/components/relatorios/TempoResposta/GrafBarraTempoRespostaFaixa.js
 **/